import { History } from 'history'
import * as LogRocket from 'logrocket'
import { routerMiddleware } from 'connected-react-router'
import {
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  Store,
  StoreEnhancer,
} from 'redux'
import * as StoreModule from './store'
import { ApplicationState, IApplicationState } from './store'
import * as StoreSagasModule from './store/sagas'
import { initializeSagas, sagaMiddleware } from './store/sagas'

export default function configureStore(
  history: History,
  initialState?: IApplicationState,
) {
  // Build middleware. These are functions that can process the actions before they reach the store.
  const windowIfDefined = typeof window === 'undefined' ? null : (window as any)

  const middleware: Middleware[] = [
    sagaMiddleware,
    routerMiddleware(history),
    LogRocket.reduxMiddleware(),
  ]

  const appState = ApplicationState.fromJS(initialState)

  const composeEnhancers = 
    (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose
  
  const store = createStore(
    StoreModule.createRootReducer(history),
    appState as any,
    composeEnhancers(
      applyMiddleware(...middleware)
    ),
  ) as Store<ApplicationState>

  initializeSagas()

  // Enable Webpack hot module replacement for reducers
  if (module.hot) {
    module.hot.accept('./store', () => {
      // Using require for HMR compatibility with current TypeScript module settings
      // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
      const nextStoreModule = require('./store') as typeof StoreModule
      store.replaceReducer(nextStoreModule.createRootReducer(history))
      // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
      const nextStoreSagasModule = require('./store/sagas') as typeof StoreSagasModule
      nextStoreSagasModule.initializeSagas()
    })
  }

  return store
}
